import { CONSTANTS } from '@/utils/constants';
import LightTheme from './theme/lightTheme';
import DarkTheme from './theme/darkTheme';
export var getPalette = function (mode, fontFamily) {
    return mode === CONSTANTS.THEME_MODE.DARK
        ? DarkTheme(fontFamily)
        : LightTheme(fontFamily);
};
